<div class="container">
    <button #focusableEleTop class="focusable-element"></button>
    <div class="row" *ngIf="!isFormValid">
        <div class="col-24">
            <div class="alert danger">
                <p><em>Error Message:</em></p>
                <ul>
                    <li *ngFor="let error of ErrorMessages"><button>{{error}}</button></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="showSuccessMsg">
        <div class="col-24">
            <div class="alert success">
                <p>{{errorConfMsg}}</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-16">
            <div class="instructions-list">
                <p><strong>Please update your email address before continuing:</strong></p>
            </div>
        </div>
    </div>

    <fieldset>
        <legend>Login ID: {{userProfileName}}</legend>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="'Email Address'"
                                        id="email"
                                        fieldId="userEmail"
                                        [text]="userEmail"
                                        (onValueChange)="userEmail = $event"
                                        [validators]="[notBlankValidator,emailValidator]" maxlength="150">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-8">
                <div class="input-wrapper">
                    <ValidatedTextField class="field"
                                        [label]="' Confirm Email Address'"
                                        id="confirmemail"
                                        fieldId="userConfirmEmail"
                                        [text]="userConfirmEmail"
                                        (onValueChange)="userConfirmEmail = $event"
                                        [validators]="[notBlankValidator,emailValidator]" maxlength="150">
                    </ValidatedTextField>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-24">
                <button class="button primary" (click)="Save()">Next</button>
            </div>
        </div>
    </fieldset>
</div>



